export class Category {
    id !: number;
    name !: string;
    parent !: number;
    orderId !: number;
}